import 'react-tooltip/dist/react-tooltip.css';
import { device } from '@/styles/common';
import { AnimatePresence, motion } from 'framer-motion';
import { Tooltip } from 'react-tooltip';
import styled from 'styled-components';

export function StatCell({
  title,
  subtitle,
  Logo,
  didLoad,
  alt,
}: {
  title: string;
  subtitle: string;
  Logo?: React.FC<{ width: number; height: number }>;
  didLoad: boolean;
  alt?: string;
}) {
  return (
    <AnimatePresence>
      <StatContainer>
        <Title layout>{title}</Title>
        {didLoad && (
          <Subtitle
            initial={{ opacity: 0, y: 6, transform: 'scale(0.85)' }}
            animate={{ opacity: 1, y: 0, transform: 'scale(1)' }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.125 }}
          >
            {alt ? (
              <>
                <Tooltip id="apr-tooltip" style={{ fontSize: '18px' }} />

                <a
                  data-tooltip-id="apr-tooltip"
                  data-tooltip-content={alt}
                  data-tooltip-place="bottom"
                >
                  {subtitle}
                </a>
              </>
            ) : (
              subtitle
            )}

            {Logo && <Logo width={16} height={16} />}
          </Subtitle>
        )}
      </StatContainer>
    </AnimatePresence>
  );
}

export const StatsContainer = styled(motion.div)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 542px;
  margin-top: 14px;

  @media ${device.mobileS} {
    width: calc(100vw - 32px);
  }
`;

export const StatContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  background: rgba(29, 34, 47, 0.7);

  width: calc(100% / 3 - 10px);

  height: 80px;

  border-radius: 12px;

  @media ${device.mobileS} {
    width: calc(100% / 3 - 4px);
  }
`;

export const Title = styled(motion.div)`
  font-size: 14px;
  color: #c9c9c9;
  font-weight: 400;
  text-align: center;
  @media ${device.mobileS} {
    font-size: 12px;
  }
`;

export const Subtitle = styled(motion.div)`
  font-size: 24px;
  color: #ffffff;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;

  @media ${device.mobileS} {
    font-size: 20px;
  }
`;
